//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  MY_PROFILE: 'My profile',
  MY_PROFILE_AND_ANALYTICS: 'My profile and analytics',
});
